import { Observable } from 'rxjs';
import { State } from './../../../models/state.model';
import { Country } from './../../../models/country.model';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { EntityModel } from '../../../models/entity.model';
import { CountryService } from '../../../services/country/country.service';
import { EntityService } from '../../../services/entity/entity.service';
import { StateService } from '../../../services/state/state.service';

@Component({
  selector: 'app-entity-form',
  templateUrl: './entity-form.component.html',
  styles: ['label.required:after {top: 0} .ui-grid-row {margin-bottom: 7px}']
})
export class EntityFormComponent implements OnInit, OnChanges {

  @Output() onUpdateElement: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() editingElement: EntityModel;

  addEditForm: FormGroup;
  validation: any;
  invalidSubmit: boolean;
  selected_country: any;
  selected_state: any;
  model = {
    country: null,
    state: null
  }
  show = {
    form: false
  }
  countries: Array<Country>
  states: Array<State>

  constructor(
    private fb: FormBuilder,
    private svc: EntityService,
    private svcCountry: CountryService,
    private svcStates: StateService) {
  }

  ngOnInit(): void {


    this.states = [];
    this.countries = [];            
        
    let Fields =  this.svc.getFields();    
    let Countries = Observable.of(null);
    let States = Observable.of(null);    

    if(this.editingElement && this.editingElement.country_id){
      let searchCountries = [
        {key: 'id',value: this.editingElement.country_id.toString()},
        {key: 'flg_state',value: "0"}
      ];
      Countries = this.svcCountry.list(null,null,searchCountries);

      let searchStates = [
        {key: 'id',value: this.editingElement.state_id.toString()},
        {key: 'flg_state',value: "0"}
      ];
      States = this.svcStates.list(null,null,searchStates);
    }

    Observable.zip(
      Fields,
      Countries,
      States
    ).subscribe(([          
      resFields,
      resCountries,
      resStates  
    ]) => {         
      
      this.validation = resFields;     
      this.countries = [];            
     
      if(resCountries && resCountries.data){
        this.countries = resCountries.data;            
      }
      
      this.states = [];            
      if(resStates && resStates.data){
        this.states = resStates.data;            
      }

      this.model.country = this.countries[0];
      this.model.state = this.states[0];


      this.addEditForm = this.fb.group({
        'name': new FormControl(this.editingElement.name),
        'description': new FormControl(this.editingElement.description),
        'vat_code': new FormControl(this.editingElement.vat_code),
        'address_1': new FormControl(this.editingElement.address_1),
        'address_2': new FormControl(this.editingElement.address_2),
        'address_number': new FormControl(this.editingElement.address_number),
        'contact_1': new FormControl(this.editingElement.contact_1),
        'contact_2': new FormControl(this.editingElement.contact_2),
        'logo': new FormControl(this.editingElement.logo),
        'logo_name': new FormControl(this.editingElement.logo_name),
        'url': new FormControl(this.editingElement.url),
        'note_1': new FormControl(this.editingElement.note_1),
        'note_2': new FormControl(this.editingElement.note_2),
        'note_3': new FormControl(this.editingElement.note_3),
        'country_id': new FormControl(this.editingElement.country_id),
        'state_id': new FormControl(this.editingElement.state_id),
      });
  

      this.show.form = true;

    });

  }
  /*** Gestione autocomplete Countries */
  filterCountrySingle(event){    
    if(event){
      let search = [
        {key: 'name',value: event.query},
        {key: 'flg_state',value: "0"}
      ];
      this.svcCountry.list(null,null,search).subscribe(res=>{        
        this.countries = [];
        this.countries = res.data;        
      })
    }
  }
  onSelectCountry(event){    
    this.addEditForm.get('country_id').setValue(event.id);
    this.model.state = null;
    this.addEditForm.get('state_id').setValue(null);
    let search = [
      {key: 'country_id',value: event.id.toString()},
      {key: 'flg_state',value: "0"}
    ];
    this.svcStates.list(null,null,search).subscribe(res=>{        
      this.states = [];
      this.states = res.data;
    })
  }
  onClearCountry(){
    this.addEditForm.get('country_id').setValue(null);
    this.addEditForm.get('state_id').setValue(null);
    this.model.country = null;
    this.model.state = null;
  }
  /*** Gestione autocomplete States */
  filterStateSingle(event){    
    if(event){
      let search = [
        {key: 'name',value: event.query},
        {key: 'country_id', value: this.model.country.id.toString()}
      ];
      this.svcStates.list(null,null,search).subscribe(res=>{        
        this.states = [];
        this.states = res.data;
      })
    }
  }
  onSelectState(event){       
    this.addEditForm.get('state_id').setValue(event.id);
  }
  onClearState(){
    this.addEditForm.get('state_id').setValue(null);
  }
  ngOnChanges(changes: SimpleChanges): void {

  }

  saveOrUpdate(): void {

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }

    let newData = Object.assign({}, this.editingElement, this.addEditForm.value);
    if (newData.id == null) {
      this.onAddElement.emit(newData);
    } else {
      this.onUpdateElement.emit(newData);
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/views/administration/entity/entity-form.component.ts